import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const FeedbackRootElement = styled.div`
    display: flex;
    width: 100%;
    background: url(${'/support/partners/images/feedback-bg.png'}) right 0 no-repeat
        ${styleVariables.inkOnBackground};
    background-size: cover;
    padding: 75px 0;
    @media (max-width: 1040px) {
        background: #000;
        padding: 34px 0;
    }
    .feedback-section {
        display: flex;
        @media (max-width: 1040px) {
            flex-direction: column;
        }
        .feedback-left {
            border-right: #e5e5e5 solid 1px;
            padding-right: 134px;
            flex: 50%;
            @media (max-width: 1040px) {
                padding-right: 56px;
                border: none;
                flex: auto;
            }
            .feedback-title {
                color: ${styleVariables.background} !important;
                margin-bottom: 18px;
            }
            .feedback-desc {
                color: ${styleVariables.background};
                @media (max-width: 1040px) {
                    margin-bottom: 18px;
                }
            }
        }

        .feedback-right {
            padding-left: 77px;
            background: none;
            display: flex;
            align-items: flex-end;
            flex: 50%;
            @media (max-width: 1040px) {
                padding-left: 0;
                flex: auto;
                button {
                    margin-right: 8px;
                }
                @media (max-width: 767px) {
                    flex-direction: column;
                    align-items: flex-start;
                    button {
                        font-size: ${styleVariables.primitivesFontSize['2']};
                        &:hover,
                        &:active,
                        &:focus {
                            font-size: ${styleVariables.primitivesFontSize['2']};
                        }
                    }
                }
            }
            .contact-partner {
                &:hover,
                &:active,
                &:focus {
                    background: #fff;
                }
                @media (max-width: 767px) {
                    font-size: ${styleVariables.primitivesFontSize['2']};
                    &:hover,
                    &:active,
                    &:focus {
                        background: #fff;
                    }
                }
            }
            .ask-button {
                margin-left: 8px;
                opacity: 1;
                border-color: #fff;
                @media (max-width: 767px) {
                    margin-left: 0;
                    margin-top: 14px;
                }
            }
        }
    }
`;
export default FeedbackRootElement;
